

import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-96 flex items-center justify-center bg-green-50"
      >
        <div className="container mx-auto px-4 text-center text-gray-900">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">elämäniについて</h1>
        </div>
      </section>

      {/* About Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">elämäniの想い</h2>
                <p className="text-gray-600 mb-4">
                  elämäni（エラマニ）は、フィンランド語で「私の人生」。当校/サロンに縁していただいた「大切な人のためにいつも頑張っている方々」が、日本の森林の香りに癒され、一息ついて「私の人生」を生きるお手伝いができればとの思いで立ち上げました。
                </p>
                <p className="text-gray-600 mb-4">
                  当校/サロンでは、日本の森林から採られた精油について学ぶことのできるアロマセラピー講座と、日本産精油だけを贅沢に使用したアロマトリートメントを提供しています。
                </p>
              </div>
              <div>
                <img 
                  src="https://static.readdy.ai/image/8c0436928c73a37898a6d6f40b2358be/eefd34b87b1476aad4af92128496bc04.jpeg"
                  alt="アロマ教室の様子"
                  className="rounded-lg shadow-lg w-full h-80 object-cover object-top"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
              <div className="order-2 lg:order-1">
                <img 
                  src="https://public.readdy.ai/ai/img_res/07ff2a2ee99a01ffb8037505f48d9765.jpg"
                  alt="日本の森林"
                  className="rounded-lg shadow-lg w-full h-80 object-cover object-top"
                />
              </div>
              <div className="order-1 lg:order-2">
                <p className="text-gray-600 mb-4">
                  「環境破壊」「森林伐採」などのイメージから、減少していると思われがちな日本の森林。しかし実際は、林業従事者の高齢化や後継者不足に伴う不十分な森林管理、安価な輸入材などにより、国産木材の利活用は停滞しており、資源として使われずに余っている木々が増えています。
                </p>
                <p className="text-gray-600 mb-4">
                  これらの木々は、人をリラックスさせたりリフレッシュさせたりしてくれる多種多様な香りの成分を持っています。木々から採られた精油（アロマ）は、私たちの心身の健康に寄り添ってくれると同時に、木材の利活用において新たな付加価値を創出し、林業の振興と環境保全にも繋がります。
                </p>
                <p className="text-gray-600">
                  elämäniでは、有難い和精油たちの力を借りて、「私の人生」を生きたいと思う方々に寄り添うとともに、日本の森林の課題解決に微力ながら貢献したいと思っています。教室/サロンとして多くの方々にアロマセラピーを提供し、共感の輪を広げながら、日本産精油の普及に取り組んでいきます。
                </p>
              </div>
            </div>

            <div className="bg-green-50 rounded-lg p-8 mb-16">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">講師紹介</h2>
              <div className="flex flex-col md:flex-row items-center gap-8">
                <div className="flex-shrink-0">
                  <img 
                    src="https://static.readdy.ai/image/8c0436928c73a37898a6d6f40b2358be/24add1ff89a5331c03c0dad37d2df32f.jpeg"
                    alt="講師プロフィール"
                    className="w-48 h-48 rounded-full object-cover object-top shadow-lg"
                  />
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">富田　芳子</h3>
                  <p className="text-green-600 font-semibold mb-4">講師/セラピスト</p>
                  <p className="text-gray-600 mb-4">
                    家族の精神疾患と向き合う中で、アロマテラピーやヨガなどの自然療法と出会う。
                    自身の重いPMS等も改善させた体験から、多くの方に広めていきたいと、アロマセラピー講師として活動を開始。
                  </p>
                  <p className="text-gray-600">
                    セラピストとして人を癒すことにも心からの生きがいを感じ、国際資格を取得。<br />
                    都会の中でも、人を癒し、人生に寄り添えるような居場所を提供したいと、2022年6月開業。
                  </p>
                  <div className="mt-6">
                    <h4 className="text-lg font-semibold text-gray-900 mb-3">保有資格</h4>
                    <ul className="text-gray-600 space-y-1">
                      <li>yuica認定 日本産精油インタープリター</li>
                      <li>NARD JAPAN認定 アロマ・インストラクター</li>
                      <li>IFPA国際プロフェッショナルアロマセラピスト</li>
                      <li>日本オーガニックビューティセラピスト協会認定 オーガニックナチュロパス</li>
                      <li>海風診療所予防医学教育認定 健康増進マイスター</li>
                      <li>クレイ・トラスト・リンク協会認定クレイソムリエ</li>
                      <li>メンタルヘルス・マネジメント検定II種</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

